import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Routes, Route, useNavigate } from "react-router-dom";
import WhatsappFloatBtn from "./components/WhatsappFloatBtn";
import ScrollToTop from "./helpers/scroll-top";
import routes from "./route";
import Cookies from "js-cookie";
import "./index.css";
import "./assets/css/mobile.css";

const App = () => {
  const [devToolsDetected, setDevToolsDetected] = useState(false);
  const navigate = useNavigate();

  const shouldRunDetection = window.location.hostname === "kalistajewels.com";
  // const shouldRunDetection = window.location.host.includes("localhost");

  useEffect(() => {
    if (!shouldRunDetection) {
      return;
    }

    const handleContextMenu = (event) => {
      event.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextMenu);

    const detectDevTool = () => {
      const threshold = 100;
      const start = +new Date();
      debugger;
      const end = +new Date();

      if (!isNaN(start) && !isNaN(end) && end - start > threshold) {
        setDevToolsDetected(true);
      }
    };

    detectDevTool();

    const intervalMilliseconds = 5000;
    const intervalId = setInterval(() => {
      detectDevTool();
    }, intervalMilliseconds);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      clearInterval(intervalId);
    };
  }, [shouldRunDetection]);

  useEffect(() => {
    if (devToolsDetected) {
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        Cookies.remove("kalista-webtoken", { path: "/" });
        Cookies.remove("kalista-web-user", { path: "/" });
        Cookies.remove("kalista-web-Id", { path: "/" });
        navigate("/login");
        setDevToolsDetected(false);
        window.location.reload();
      }, 5000);
    }
  }, [devToolsDetected, navigate]);

  return (
    <>
      <ScrollToTop>
        <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={8}
          toastOptions={{
            className: "",
            duration: 5000,
            removeDelay: 1000,
          }}
        />
        <WhatsappFloatBtn />
        <Routes>
          {routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Routes>
      </ScrollToTop>
      {devToolsDetected && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100dvh",
            backgroundColor: "rgba(0,0,0,0.9)",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "2em",
            zIndex: 9999,
          }}
        >
          DEVTOOLS detected. all operations will be terminated.
        </div>
      )}
    </>
  );
};

export default App;